/* exported timeOffset, countLoggedIn, countLoggedInForQueues, getDevId, homegetStatusButtonNoFade,
 incWaitCounter, sGetAgentData, sGetQueueData, updateAgent, updateAgentDevice, updateQueue */
/* global StatsGrid, CallCenterGraphs, NSAgentsSearch, activeDevice, getMMss, subscriptions,
 getSecDiffUtc, durationCounter, NSAgentsCallQueues */
var timeOffset = 0;
var bigButtonHoldOff = false;

function countLoggedIn(queue) {
  var loggedInAgents = 0;

  $('#agents-table .agent_in_queue').each(function () {
    var agentQueue = $(this).data('queue');
    var agentStatus = $(this).data('status');

    if (agentQueue == queue
      && (agentStatus == 'immediate' || agentStatus == 'available' || agentStatus == 'offnet')
    ) {
      loggedInAgents += 1;
    }
  });

  $('#queue' + queue + ' .loggedinagents').text(loggedInAgents);
}

function updateQueue(queue, data) {
  $.each(data, function (key, value) {
    if (key == 'count_session') {
      $('#queue' + queue + ' .activecall').text(value);

    } else if (key == 'gau_session' && !('count_session' in data)) {
      // i believe this is a older now deprecated method.
      $('#queue' + queue + ' .activecall').text(value);
    } else if (key == 'gau_queue_length') {
      $('#queue' + queue + ' .queuelength').text(value);

      if ($('#dash-stats-grid-cw').length) {
        StatsGrid.cw();
      }
    } else if (key == 'gau_agent_available') {
      // Column labeled as Idle Agents
      $('#queue' + queue + ' .availagents').text(value);
      countLoggedIn(queue);
    } else if (key == 'gau_queue_max_wait') {
      $('#queue' + queue + ' .waittime').data('wait-sec', value);
    }
  });
  // sum queue length and send it to dashboard stats grid
}

function countLoggedInForQueues() {
  if ($('.loggedinagents').length > 0 && $('.agent_in_queue').length > 0) {
    $('#manager_queues .queue-row').each(function () {
      var queue = $(this).attr('id')
        .replace('queue', '');

      countLoggedIn(queue);
    });
  }
}

function getDevId(value) {
  value = value.replace(/@/gi, '-');
  value = value.replace(/:/gi, '-');
  value = value.replace(/\./gi, '-');

  return value;
}

function updateAgent(deviceAor, huntgroupName, data) {
  deviceAor = getDevId(deviceAor);

  // contact_id is a class the uniquely identifies agent presence icon. is a class because there
  // may be two agents table on one page when "edit queue" modal is open
  var contactId = '.agent-' + deviceAor + '-' + huntgroupName;
  var contactIdNoHg = '.agent-' + deviceAor;
  var contactIdFullRow = '.agent-' + deviceAor + '-' + huntgroupName + '-fullrow';
  var contactIdQueueList = '.agent-' + deviceAor + '-' + huntgroupName + '.agent_in_queue';
  var contactIdQueueListNoHg = '.agent-' + deviceAor + '.agent_in_queue';
  var contactIdStatus = '.agent-' + deviceAor + '-' + huntgroupName + '.agent-status-text';
  var quickStatus = 'offline';

  $(contactId + '  .agentcalls').text(data.session_count);
  $(contactIdFullRow).data('availindex', 'b');
  $(contactIdQueueList).data('status', data.entry_option);

  if (data.entry_option == 'immediate' || data.entry_option == 'Logged In') {
    $(contactIdStatus).html(_('Logged In'));

    if (data.entry_status == 'available') {
      data.entry_option = _('Logged In');
      $(contactIdFullRow).data('availindex', 'a');
    } else {
      data.entry_option = _('Logged Out');
      $(contactIdFullRow).data('availindex', 'b');
    }

    quickStatus = 'online';
  } else if (data.entry_option == 'disabled' || data.entry_option == 'Disabled') {
    $(contactIdStatus).html(_('Logged Out'));
    data.entry_option = _('Disabled');
  } else if (data.entry_status == 'available') {
    $(contactIdStatus).html(_('Logged In'));
    data.entry_option = _('Available One Call');
  } else {
    data.entry_option = _('Logged Out');
    $(contactIdStatus).html(_('Logged Out'));
  }

  if (data.entry_device != 'reg') {
    $(contactIdStatus).html(_('Offline'));
  }

  $('.agent-status-group-success').each(function () {
    if (huntgroupName === $(this).data('queue') && deviceAor === getDevId($(this).data('agent'))) {
      NSAgentsCallQueues.updateStatus(this.id.replace('agent_queue_', ''), quickStatus, false);
    }
  });

  $(contactId).removeClass('loggedin loggedout onphone');

  if (data.entry_status == 'available') {
    if (data.session_count > 0) {
      $(contactId).addClass('onphone');
      $(contactId).data('original-title', _('On a call'));
      $(contactIdFullRow).data('availindex', 'a');
    } else {
      $(contactId).addClass('loggedin');
      $(contactId).data('original-title', _('Available'));
    }

    $(contactIdFullRow).data('availindex', 'a');
  } else if (data.session_count > 0) {
    $(contactId).addClass('onphone');
    $(contactId).data('original-title', _('On a call'));
    $(contactIdFullRow).data('availindex', 'a');
  } else if (data.entry_option == 'Logged In') {
    $(contactId).data('original-title', _('Logged In'));
    $(contactId).addClass('loggedin');
    $(contactIdFullRow).data('availindex', 'a');
  } else {
    $(contactId).data('original-title', _('Logged Out'));
    $(contactId).addClass('loggedout');
  }

  var tmpTitle = _('Logged Out');
  var onACallTitle = _('On a call');
  var availableTitle = _('Available');
  var tmpClass = 'loggedout';
  var tmpAvailableIndex = 'b';
  var updated = false;

  if ($(contactIdQueueListNoHg).length > 1) {
    $(contactIdQueueListNoHg).each(function () {
      updated = true;

      if (tmpClass == 'onphone' || tmpClass == 'loggedin') {
        return;
      }

      if (data.session_count > 0) {
        tmpClass = 'onphone';
        tmpTitle = onACallTitle;
        tmpAvailableIndex = 'a';
      }

      if ($(this).data('status') == 'immediate' || $(this).data('status') == 'available') {
        if (data.entry_status == 'available') {
          tmpClass = 'loggedin';
          tmpTitle = availableTitle;
          tmpAvailableIndex = 'a';
        }
      }
    });
  }

  if (updated) {
    $(contactIdNoHg + '.agent-fullrow').data('availindex', tmpAvailableIndex);
    $(contactIdNoHg + '.agent-fullrow').data('original-title', tmpTitle);
    $(contactIdNoHg + '.agent-presence').data('original-title', tmpTitle);
    $(contactIdNoHg + '.agent-presence').attr('title', tmpTitle);
    $(contactIdNoHg + '.agent-presence').removeClass('loggedin loggedout onphone');
    $(contactIdNoHg + '.agent-presence').addClass(tmpClass);
  }

  if (typeof CallCenterGraphs.processAgentTotals === 'function') {
    CallCenterGraphs.processAgentTotals();
  }

  if (typeof NSAgentsSearch !== 'undefined'
    && typeof NSAgentsSearch.receivedSocketUpdate === 'function'
  ) {
    NSAgentsSearch.receivedSocketUpdate();
  }
}

function homegetStatusButtonNoFade() {
  if (!bigButtonHoldOff) {
    bigButtonHoldOff = true;
    setTimeout(function () {
      bigButtonHoldOff = false;
    }, 250);

    setTimeout(function () {
      $.get('/portal/agents/bigbutton/' + activeDevice, function (data) {
        // now uses activeDevice
        $('#agent-status-panel-home').html(data);
      });
    }, 25);
  }
}

function updateAgentDevice(deviceAor, huntgroupName, data) {
  // Per Queue UI block
  var queueClass = 'inuse';
  // show login button
  var loginStyle = 'display: inline-block;';
  // hide logout button
  var logoutStyle = 'display: none;';
  var isSingleCall = $('#online-button')
    .text()
    .includes('Single-Call');

  if ((data.entry_option == 'immediate' || data.entry_option == 'manual') && data.entry_status == 'available') {
    queueClass = 'open';
    // hide login button, immediate / avail means were logged in
    loginStyle = 'display: none;';
    // show logout button
    logoutStyle = 'display: inline-block;';
  } else if (data.entry_option == 'manual' && data.entry_status == 'available' && isSingleCall) {
    queueClass = 'open';
    loginStyle = 'display: none;'; // hide login button, immediate/avail means were logged in
    logoutStyle = 'display: inline-block;'; // show logout button
  }

  $('#queue' + huntgroupName + ' .presence').attr('class', 'agent_status presence ' + queueClass);
  $('#queue' + huntgroupName + ' button.queue-login').attr('style', loginStyle);
  $('#queue' + huntgroupName + ' button.queue-logout').attr('style', logoutStyle);
  // END Per Queue UI block

  deviceAor = getDevId(deviceAor);
  huntgroupName = getDevId(huntgroupName);

  homegetStatusButtonNoFade();

  $('.huntgroup_for_device').each(function () {
    if ($(this).data('huntgroup') == huntgroupName) {
      $(this).data('mode', data.entry_option);
      $(this).data('status', data.entry_status);
    }
  });
}

function incWaitCounter() {
  $('.wait_counter').each(
    function () {
      var sec = $(this).data('wait-sec');

      if (sec != 0 || sec != '0') {
        sec = parseInt(sec, 10) + 1;
        $(this).data('wait-sec', '' + sec);
        $(this).text(getMMss(sec));
      } else {
        $(this).text('-');
      }
    }
  );

  setTimeout(incWaitCounter, 1000);
}

function sGetQueueData(type, domain, filter) {
  if (typeof socket == 'undefined') {
    log('sGetQueueData: typeof socket undefined');

    return;
  }

  var options = {
    domain: domain,
    type: 'queue',
  };

  if (typeof filter != 'undefined' && filter != '' && filter != '*') {
    options.filter = filter;
  }

  netsapiens.api.getAccessToken()
    .then(function (accessToken) {
      options.bearer = accessToken;
      subscriptions.push(options);
      socket.emit('subscribe', options);
    });

  socket.on('queue', function (data) {
    if (type == 'manager' || type == 'agent') {
      updateQueue(data.user, data);
    }
  });
}

function sGetAgentData(type, domain, filter) {
  if (typeof socket == 'undefined') {
    return;
  }

  var options = {
    domain: domain,
    type: 'agent',
  };

  if (typeof filter != 'undefined' && filter !== '' && filter !== '*' && filter.includes('@')) {
    options.filter = filter;
  } else if (typeof filter != 'undefined' && filter !== '' && filter !== '*') {
    options.filter = 'sip:' + filter + '@' + domain;
  }

  netsapiens.api.getAccessToken()
    .then(function (accessToken) {
      options.bearer = accessToken;
      subscriptions.push(options);
      socket.emit('subscribe', options);
    });

  socket.on('agent', function (data) {
    updateAgent(data.device_aor, data.huntgroup_name, data);
  });

  socket.on('agent-device', function (data) {
    updateAgentDevice(data.device_aor, data.huntgroup_name, data);
  });
}

$(function () {
  if (typeof servertime != 'undefined') {
    timeOffset = getSecDiffUtc(servertime);
  }

  setInterval(durationCounter, 1000);
});
